<template>
  <div class="row">
    <div class="col-md-8 col-lg-offset-2">
      <div class="register-form">
        <div class="row">
          <div class="col-md-12 text-center">
            <h4 class="app-name text-colored m-0">Pendaftaran Peradi 2023</h4>
          </div>
        </div>

        <form>
          <div class="row mt-60">
            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Nama<sup>*</sup></label>
                <input
                  type="text"
                  name="name"
                  class="form-control"
                  placeholder="Nama"
                  v-model="data.name"
                  v-validate="'required'"
                />
                <div class="text-danger">{{ veeErrors.first("name") }}</div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>NIA/NIM<sup>*</sup></label>
                <input
                  type="text"
                  name="uuid"
                  class="form-control"
                  placeholder="NIA/NIM"
                  v-model="data.uuid"
                  v-validate="'required'"
                />
                <div class="text-danger">{{ veeErrors.first("uuid") }}</div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Email<sup>*</sup></label>
                <input
                  type="text"
                  name="email"
                  class="form-control"
                  placeholder="Email"
                  v-model="data.email"
                  v-validate="'required'"
                />
                <div class="text-danger">
                  {{ veeErrors.first("email") }}
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Phone<sup>*</sup></label>
                <input
                  type="text"
                  name="phone"
                  class="form-control"
                  placeholder="Phone"
                  v-model="data.phone"
                  v-validate="'required'"
                />
                <div class="text-danger">
                  {{ veeErrors.first("phone") }}
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Jenis Kelamin<sup>*</sup></label>
                <multiselect
                  v-model="selectedGender"
                  placeholder="Please select an option"
                  label="name"
                  track-by="name"
                  name="gender"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :options="genders"
                  :multiple="false"
                  :allow-empty="false"
                  :preselect-first="false"
                  v-validate="'required'"
                  @input="onChangeGender"
                >
                </multiselect>
                <div class="text-danger">{{ veeErrors.first("gender") }}</div>
              </div>
            </div>

            <!-- <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Kategori Peserta<sup>*</sup></label>
                <multiselect
                  v-model="selectedCategory"
                  placeholder="Please select an option"
                  label="name"
                  track-by="name"
                  name="category"
                  :close-on-select="true"
                  :clear-on-select="true"
                  :options="categories"
                  :multiple="false"
                  :allow-empty="false"
                  :preselect-first="false"
                  v-validate="'required'"
                  @input="onChangeCategory"
                >
                </multiselect>
                <div class="text-danger">{{ veeErrors.first("category") }}</div>
              </div>
            </div> -->

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>Jabatan<sup>*</sup></label>
                <input
                  type="text"
                  name="jabatan"
                  class="form-control"
                  placeholder="Jabatan"
                  v-model="data.jabatan"
                  v-validate="'required'"
                />
                <div class="text-danger">{{ veeErrors.first("jabatan") }}</div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group mb-30">
                <label>DPC<small>(optional)</small></label>
                <input
                  type="text"
                  name="dpc"
                  class="form-control"
                  placeholder="DPC"
                  v-model="data.dpc"
                />
                <div class="text-danger">{{ veeErrors.first("dpc") }}</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group mb-0 mt-10 text-center">
                <button
                  class="btn btn-colored btn-success btn-lg btn-submit btn-block"
                  data-loading-text="Please wait..."
                  @click.prevent="submit"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataprop"],
  filters: {
    formatSize: function (value) {
      if (!value) return "";
      let valKB = 0.000001 * value;
      return `${valKB.toFixed(2)} MB`;
    },
  },
  data() {
    return {
      url: "",
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      type: "",
      main_folder: "assets/file_upload/bukti_bayar",
      data: {},
      files: [],
      selectedGender: null,
      genders: [
        { id: 1, name: "Laki-laki" },
        { id: 0, name: "Perempuan" },
      ],
      selectedCategory: null,
      categories: [],
    };
  },
  created() {
    this.initial();
  },
  methods: {
    initial() {
    //   this.getCategory();
    },
    checkEmail() {
      this.$validator.extend("email_exists", {
        getMessage: (field) => `This email has been registered`,
        validate: (value) => {
          return axios
            .get("/register/checkemail/" + value)
            .then((response) => {
              return {
                valid: response.data.valid,
              };
            })
            .catch((error) => {
              return { error: response.error.val };
            });
        },
      });
    },
    async getCategory() {
      let url = "/register/category/list";
      await axios.get(url).then((response) => {
        this.categories = response.data;
      });
    },
    onChangeGender() {
      this.data.gender = this.selectedGender.id;
    },
    onChangeCategory() {
      this.data.category_id = this.selectedCategory.id;
    },
    submit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.confirmAlert("Simpan data?", "", "axiosForm");
        } else {
          this.$swal("Perhatian!", "Silahkan lengkapi form!", "warning");
        }
      });
    },
    confirmAlert(msg, txt, action) {
      this.$swal({
        title: msg,
        text: txt,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.isConfirmed) {
          switch (action) {
            case "axiosForm":
              this.axiosForm(this.data);
              break;
          }
        }
      });
    },
    axiosForm(data) {
      let url = `register`;
      axios
        .post(url, data)
        .then((response) => {
          let msg = response.data.message;
          if (msg == "success") {
            let dataEmit = {
              action: "notif",
              data: response.data.data,
            };
            this.$emit("data-prop", dataEmit);
          } else {
            this.$swal("Error!", "Something wrong!", "error");
          }
        })
        .catch((error) => {
          const errors = error?.response?.data?.errors;
          if (errors.uuid && errors.uuid[0] === "uuid is already exists") {
            this.$swal("NIA sudah terdaftar", "NIA harus unik.", "error");
          } else if (
            errors.email &&
            errors.email[0] === "email is already exists"
          ) {
            this.$swal("Email sudah terdaftar", "Email harus unik.", "error");
          } else {
            this.$swal("Error!", "Something wrong!", "error");
          }
        });
    },
    formatRupiah(money) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(money);
    },
    customLabel({ name, price }) {
      price = this.formatRupiah(price);
      return `${name} (${price})`;
    },
    getImage(link) {
      return `${this.main_folder}/${link}`;
    },
    validateFileSize(size) {
      return true;
      if (0.000001 * size > 2.048) {
        return false;
      }
      return true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile) {
        let check = this.validateFileSize(newFile.size);
        if (!check) {
          this.$refs.upload.remove(newFile);
          this.$swal("Error!", "Max file upload 2 MB.", "error");
        } else {
          this.$refs.upload.active = true;
        }
      }
    },
    async uploadFile(file, component) {
      let result = await component.uploadHtml5(file),
        filename = result.response.filename;
      this.files[0].name = filename;
      this.data.bukti_bayar = filename;
      return result;
    },
    formData(obj) {
      var formData = new FormData();
      for (var key in obj) {
        formData.append(key, obj[key]);
      }
      return formData;
    },
    alertError(msg) {
      this.$swal({
        icon: "error",
        title: "Maaf terdapat gangguan, silahkan coba kembali",
        text: msg,
        type: "warning",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Mengerti",
      }).then((result) => {
        if (result.value) {
        }
      });
    },
  },
};
</script>
<style>
.register-form {
  border: 2px solid var(--main);
  border-radius: 10px;
  padding: 30px 30px;
}
.form-control {
  height: 40px !important;
}

.box-info {
  background: #eee;
  padding: 10px 20px;
}
option:disabled {
  background: rgb(170, 170, 170);
}
.mx-datepicker {
  display: block;
  width: 100%;
}
@media (max-width: 767px) {
  .app-name {
    font-size: 1.7rem;
  }
}
</style>
